import { render } from "./House2.vue?vue&type=template&id=754d0e39"
import script from "./House2.vue?vue&type=script&lang=js"
export * from "./House2.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gimmetm/work/projects/tnms-go/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__